import { Grid, GridProps, Typography } from "@mui/material";
import { PropsWithChildren, ReactNode } from "react";

type Props = {
  label?: string;
  tooltip?: ReactNode;
  labelSize?: number;
  fieldSize?: number;
  GridLabelProps?: GridProps;
  GridFieldProps?: GridProps;
  multiRow?: boolean;
  labelPosition?: "left" | "top";
};

const FormGridRow = ({
  label,
  tooltip,
  children,
  labelSize = 3,
  fieldSize = 9,
  GridLabelProps = {},
  GridFieldProps = {},
  multiRow = false,
  labelPosition = "left",
}: PropsWithChildren<Props>) => {
  if (labelPosition === "top") {
    return (
      <>
        {label && (
          <Grid item xs={12} {...GridLabelProps}>
            <Typography variant="secondary">{label}</Typography>
            {tooltip}
          </Grid>
        )}
        <Grid item xs={12} mb={0.5} {...GridFieldProps}>
          {children}
        </Grid>
      </>
    );
  }

  return (
    <>
      <Grid
        container
        item
        xs={labelSize}
        justifyContent="flex-end"
        alignItems="center"
        alignSelf={multiRow ? "flex-start" : "unset"}
        {...GridLabelProps}
        sx={{
          ...(multiRow && { mt: "5px" }),
          ...GridLabelProps.sx,
        }}
      >
        {label && (
          <Typography variant="secondary" textAlign="end">
            {label}
          </Typography>
        )}
        {tooltip}
      </Grid>
      <Grid item xs={fieldSize} {...GridFieldProps}>
        {children}
      </Grid>
    </>
  );
};

export default FormGridRow;
